import React from 'react';

import { Skeleton } from '@crossnokaye/ux-common';

import { ActionComponentConfig, ActionComponentConfigKind } from '@repo/sdk/models/components';

import { ActionButton } from '@/features/equipment-browser/action-components/action-button';
import { ActionButtonWithConfirmation } from '@/features/equipment-browser/action-components/action-button-with-confirmation';
import { ActionDropdown } from '@/features/equipment-browser/action-components/action-dropdown';

import { ActionComponentBadge } from './action-component-badge';
import { ActionComponentProps } from './types';

export const ActionComponent: React.FC<ActionComponentProps> = ({ state, ...props }) => {
  const actionComponentConfig = state?.actionComponentConfig as ActionComponentConfig;

  switch (actionComponentConfig?.kind) {
    case ActionComponentConfigKind.Badge: {
      return <ActionComponentBadge state={state} />;
    }
    case ActionComponentConfigKind.Button: {
      if (actionComponentConfig?.buttonComponentActionConfig?.confirmationDialogConfig) {
        return (
          <ActionButtonWithConfirmation
            key={`button-state-${state?.stateName}`}
            state={state}
            {...props}
          />
        );
      }
      return <ActionButton key={`button-state-${state?.stateName}`} state={state} {...props} />;
    }
    case ActionComponentConfigKind.Dropdown: {
      return <ActionDropdown key={`dropdown-state-${state?.stateName}`} state={state} {...props} />;
    }
    default: {
      return (
        <Skeleton
          className="w-full h-8 mb-thin"
          data-testid={`skeleton-action-state-${state?.stateName}`}
          key={`skeleton-state-${state?.stateName}`}
        />
      );
    }
  }
};
